// GENERATED FILE — do not edit by hand.
//   node scripts/generate-destinations.mjs
//
// Every tab and every named panel in the app, with the page it lives on. Global
// search matches these so "Stock Pick Suggestions" finds the card on Cold Store
// Outflow, rather than nothing at all. Visibility is decided at match time against
// the sidebar the user actually has, so a destination can never point at a page
// their tenant or role does not have.
//
//   kind  'tab' | 'widget'
//   path  the page route
//   tab       the tab to activate on arrival (tabs only)
//   tabParam  set when the page reads its tab from the URL ('tab'); absent for a
//             Radix strip, which is clicked rather than navigated to
//   find  the on-screen text to scroll to and flash
//   features feature flags required for the panel to render

export const DESTINATIONS = [
  {
    "id": "tab:/accounts:leave",
    "kind": "tab",
    "name": "Attendance & Leave",
    "page": "Accounts",
    "path": "/accounts",
    "tab": "leave",
    "find": "Attendance & Leave"
  },
  {
    "id": "tab:/accounts:automation",
    "kind": "tab",
    "name": "Automation",
    "page": "Accounts",
    "path": "/accounts",
    "tab": "automation",
    "find": "Automation"
  },
  {
    "id": "tab:/accounts:payables",
    "kind": "tab",
    "name": "Contractor/Material Bills",
    "page": "Accounts",
    "path": "/accounts",
    "tab": "payables",
    "find": "Contractor/Material Bills"
  },
  {
    "id": "tab:/accounts:overview",
    "kind": "tab",
    "name": "Overview",
    "page": "Accounts",
    "path": "/accounts",
    "tab": "overview",
    "find": "Overview"
  },
  {
    "id": "tab:/accounts:payroll",
    "kind": "tab",
    "name": "Payroll & Benefits",
    "page": "Accounts",
    "path": "/accounts",
    "tab": "payroll",
    "find": "Payroll & Benefits"
  },
  {
    "id": "tab:/accounts:people",
    "kind": "tab",
    "name": "People",
    "page": "Accounts",
    "path": "/accounts",
    "tab": "people",
    "find": "People"
  },
  {
    "id": "tab:/accounts:settlements",
    "kind": "tab",
    "name": "Settlement Queue",
    "page": "Accounts",
    "path": "/accounts",
    "tab": "settlements",
    "find": "Settlement Queue"
  },
  {
    "id": "tab:/accounts:expenses",
    "kind": "tab",
    "name": "Travel Expenses",
    "page": "Accounts",
    "path": "/accounts",
    "tab": "expenses",
    "find": "Travel Expenses"
  },
  {
    "id": "widget:/accounts:bonuses-benefits-adjustments",
    "kind": "widget",
    "name": "Bonuses, Benefits & Adjustments",
    "page": "Accounts",
    "path": "/accounts",
    "find": "Bonuses, Benefits & Adjustments"
  },
  {
    "id": "widget:/accounts:contractor-billing",
    "kind": "widget",
    "name": "Contractor Billing",
    "page": "Accounts",
    "path": "/accounts",
    "find": "Contractor Billing"
  },
  {
    "id": "widget:/accounts:leave-balances-fy",
    "kind": "widget",
    "name": "Leave Balances · FY",
    "page": "Accounts",
    "path": "/accounts",
    "find": "Leave Balances · FY"
  },
  {
    "id": "widget:/accounts:leave-requests",
    "kind": "widget",
    "name": "Leave Requests",
    "page": "Accounts",
    "path": "/accounts",
    "find": "Leave Requests"
  },
  {
    "id": "widget:/accounts:needs-attention",
    "kind": "widget",
    "name": "Needs Attention",
    "page": "Accounts",
    "path": "/accounts",
    "find": "Needs Attention"
  },
  {
    "id": "widget:/accounts:non-rm-material",
    "kind": "widget",
    "name": "Non-RM Material",
    "page": "Accounts",
    "path": "/accounts",
    "find": "Non-RM Material"
  },
  {
    "id": "widget:/accounts:open-trips",
    "kind": "widget",
    "name": "Open Trips",
    "page": "Accounts",
    "path": "/accounts",
    "find": "Open Trips"
  },
  {
    "id": "widget:/accounts:open-wage-bills",
    "kind": "widget",
    "name": "Open Wage Bills",
    "page": "Accounts",
    "path": "/accounts",
    "find": "Open Wage Bills"
  },
  {
    "id": "widget:/accounts:pay-day-summary-to",
    "kind": "widget",
    "name": "Pay-Day Summary · to",
    "page": "Accounts",
    "path": "/accounts",
    "find": "Pay-Day Summary · to"
  },
  {
    "id": "widget:/accounts:recent-material-receipts",
    "kind": "widget",
    "name": "Recent Material Receipts",
    "page": "Accounts",
    "path": "/accounts",
    "find": "Recent Material Receipts"
  },
  {
    "id": "widget:/accounts:statutory-registers",
    "kind": "widget",
    "name": "Statutory Registers",
    "page": "Accounts",
    "path": "/accounts",
    "find": "Statutory Registers"
  },
  {
    "id": "widget:/accounts:this-pay-cycle",
    "kind": "widget",
    "name": "This Pay Cycle",
    "page": "Accounts",
    "path": "/accounts",
    "find": "This Pay Cycle"
  },
  {
    "id": "widget:/accounts:trip-sheet",
    "kind": "widget",
    "name": "Trip Sheet",
    "page": "Accounts",
    "path": "/accounts",
    "find": "Trip Sheet"
  },
  {
    "id": "widget:/accounts/create:bill-information",
    "kind": "widget",
    "name": "Bill Information",
    "page": "Create Wage Bill",
    "path": "/accounts/create",
    "find": "Bill Information"
  },
  {
    "id": "widget:/accounts/create:bill-totals",
    "kind": "widget",
    "name": "Bill Totals",
    "page": "Create Wage Bill",
    "path": "/accounts/create",
    "find": "Bill Totals"
  },
  {
    "id": "widget:/accounts/create:review-submit",
    "kind": "widget",
    "name": "Review & Submit",
    "page": "Create Wage Bill",
    "path": "/accounts/create",
    "find": "Review & Submit"
  },
  {
    "id": "widget:/accounts/create:worker",
    "kind": "widget",
    "name": "Worker #",
    "page": "Create Wage Bill",
    "path": "/accounts/create",
    "find": "Worker #"
  },
  {
    "id": "widget:/accounts/create:worker-line-items",
    "kind": "widget",
    "name": "Worker Line Items",
    "page": "Create Wage Bill",
    "path": "/accounts/create",
    "find": "Worker Line Items"
  },
  {
    "id": "widget:/accounts/create:workers-summary",
    "kind": "widget",
    "name": "Workers Summary",
    "page": "Create Wage Bill",
    "path": "/accounts/create",
    "find": "Workers Summary"
  },
  {
    "id": "tab:/admin:company",
    "kind": "tab",
    "name": "Company Settings",
    "page": "Admin Panel",
    "path": "/admin",
    "tab": "company",
    "find": "Company Settings"
  },
  {
    "id": "tab:/admin:access",
    "kind": "tab",
    "name": "Feature Access",
    "page": "Admin Panel",
    "path": "/admin",
    "tab": "access",
    "find": "Feature Access"
  },
  {
    "id": "tab:/admin:inventory-approvals",
    "kind": "tab",
    "name": "Inventory Approvals",
    "page": "Admin Panel",
    "path": "/admin",
    "tab": "inventory-approvals",
    "find": "Inventory Approvals"
  },
  {
    "id": "tab:/admin:notifications",
    "kind": "tab",
    "name": "Notifications",
    "page": "Admin Panel",
    "path": "/admin",
    "tab": "notifications",
    "find": "Notifications"
  },
  {
    "id": "tab:/admin:approvals",
    "kind": "tab",
    "name": "Pending Approvals",
    "page": "Admin Panel",
    "path": "/admin",
    "tab": "approvals",
    "find": "Pending Approvals"
  },
  {
    "id": "tab:/admin:photos",
    "kind": "tab",
    "name": "Photo Tracking",
    "page": "Admin Panel",
    "path": "/admin",
    "tab": "photos",
    "find": "Photo Tracking"
  },
  {
    "id": "tab:/admin:profile",
    "kind": "tab",
    "name": "Profile",
    "page": "Admin Panel",
    "path": "/admin",
    "tab": "profile",
    "find": "Profile"
  },
  {
    "id": "tab:/admin:supervision",
    "kind": "tab",
    "name": "Stages",
    "page": "Admin Panel",
    "path": "/admin",
    "tab": "supervision",
    "find": "Stages"
  },
  {
    "id": "tab:/admin:users",
    "kind": "tab",
    "name": "Users & Access",
    "page": "Admin Panel",
    "path": "/admin",
    "tab": "users",
    "find": "Users & Access"
  },
  {
    "id": "widget:/admin:important-notes",
    "kind": "widget",
    "name": "⚠️ Important Notes",
    "page": "Admin Panel",
    "path": "/admin",
    "find": "⚠️ Important Notes"
  },
  {
    "id": "widget:/admin:company-details",
    "kind": "widget",
    "name": "Company Details",
    "page": "Admin Panel",
    "path": "/admin",
    "find": "Company Details"
  },
  {
    "id": "widget:/admin:email-alerts",
    "kind": "widget",
    "name": "Email Alerts",
    "page": "Admin Panel",
    "path": "/admin",
    "find": "Email Alerts"
  },
  {
    "id": "widget:/admin:invoice-preview",
    "kind": "widget",
    "name": "ℹ️ Invoice Preview",
    "page": "Admin Panel",
    "path": "/admin",
    "find": "ℹ️ Invoice Preview"
  },
  {
    "id": "widget:/admin:inventory-approval-stakeholders",
    "kind": "widget",
    "name": "Inventory Approval Stakeholders",
    "page": "Admin Panel",
    "path": "/admin",
    "find": "Inventory Approval Stakeholders"
  },
  {
    "id": "widget:/admin:invoice-signature-pdf",
    "kind": "widget",
    "name": "Invoice signature (PDF)",
    "page": "Admin Panel",
    "path": "/admin",
    "find": "Invoice signature (PDF)"
  },
  {
    "id": "widget:/admin:notification-delivery-settings",
    "kind": "widget",
    "name": "Notification Delivery Settings",
    "page": "Admin Panel",
    "path": "/admin",
    "find": "Notification Delivery Settings"
  },
  {
    "id": "widget:/admin:pending-approvals",
    "kind": "widget",
    "name": "Pending Approvals",
    "page": "Admin Panel",
    "path": "/admin",
    "find": "Pending Approvals"
  },
  {
    "id": "widget:/admin:photo-tracking-all-stages",
    "kind": "widget",
    "name": "Photo Tracking - All Stages",
    "page": "Admin Panel",
    "path": "/admin",
    "find": "Photo Tracking - All Stages"
  },
  {
    "id": "widget:/admin:smtp-configuration",
    "kind": "widget",
    "name": "SMTP Configuration",
    "page": "Admin Panel",
    "path": "/admin",
    "find": "SMTP Configuration"
  },
  {
    "id": "widget:/admin:users-access-control",
    "kind": "widget",
    "name": "Users & Access Control",
    "page": "Admin Panel",
    "path": "/admin",
    "find": "Users & Access Control"
  },
  {
    "id": "widget:/admin:whatsapp-alerts",
    "kind": "widget",
    "name": "WhatsApp Alerts",
    "page": "Admin Panel",
    "path": "/admin",
    "find": "WhatsApp Alerts"
  },
  {
    "id": "widget:/admin/market-rates:sale-rate-master",
    "kind": "widget",
    "name": "Sale Rate Master",
    "page": "Market Rates",
    "path": "/admin/market-rates",
    "find": "Sale Rate Master"
  },
  {
    "id": "widget:/admin/wastage-dashboard:stage-wise-wastage",
    "kind": "widget",
    "name": "Stage-wise Wastage",
    "page": "Wastage Dashboard",
    "path": "/admin/wastage-dashboard",
    "find": "Stage-wise Wastage"
  },
  {
    "id": "widget:/admin/wastage-dashboard:threshold-breach-alerts",
    "kind": "widget",
    "name": "Threshold Breach Alerts",
    "page": "Wastage Dashboard",
    "path": "/admin/wastage-dashboard",
    "find": "Threshold Breach Alerts"
  },
  {
    "id": "widget:/admin/yield-benchmarks:benchmarks",
    "kind": "widget",
    "name": "Benchmarks",
    "page": "Yield Benchmarks",
    "path": "/admin/yield-benchmarks",
    "find": "Benchmarks"
  },
  {
    "id": "widget:/agents:risk-timeline",
    "kind": "widget",
    "name": "Risk Timeline",
    "page": "Agents",
    "path": "/agents",
    "find": "Risk Timeline"
  },
  {
    "id": "widget:/analytics/cost-analyser:batches-under-this-lot-cost-per-kg",
    "kind": "widget",
    "name": "Batches under this Lot — Cost per kg (₹ & $)",
    "page": "Cost Analyser",
    "path": "/analytics/cost-analyser",
    "find": "Batches under this Lot — Cost per kg (₹ & $)"
  },
  {
    "id": "widget:/analytics/cost-analyser:cost-per-kg-by-product-type",
    "kind": "widget",
    "name": "Cost per kg — by Product Type",
    "page": "Cost Analyser",
    "path": "/analytics/cost-analyser",
    "find": "Cost per kg — by Product Type"
  },
  {
    "id": "widget:/analytics/cost-analyser:cost-waterfall",
    "kind": "widget",
    "name": "Cost Waterfall",
    "page": "Cost Analyser",
    "path": "/analytics/cost-analyser",
    "find": "Cost Waterfall"
  },
  {
    "id": "widget:/analytics/cost-analyser:final-export-price-calculation",
    "kind": "widget",
    "name": "Final Export Price Calculation",
    "page": "Cost Analyser",
    "path": "/analytics/cost-analyser",
    "find": "Final Export Price Calculation"
  },
  {
    "id": "widget:/analytics/cycle-times:lot-cycle-times",
    "kind": "widget",
    "name": "Lot Cycle Times",
    "page": "Cycle Times",
    "path": "/analytics/cycle-times",
    "find": "Lot Cycle Times"
  },
  {
    "id": "widget:/analytics/cycle-times:where-the-plant-is-stuck-right-now",
    "kind": "widget",
    "name": "Where the plant is stuck right now",
    "page": "Cycle Times",
    "path": "/analytics/cycle-times",
    "find": "Where the plant is stuck right now"
  },
  {
    "id": "widget:/analytics/form-yields:form-yield-standards",
    "kind": "widget",
    "name": "Form Yield Standards",
    "page": "Form Yields",
    "path": "/analytics/form-yields",
    "find": "Form Yield Standards"
  },
  {
    "id": "tab:/analytics/grade-mix-calculator:reverse",
    "kind": "tab",
    "name": "What should I buy?",
    "page": "Grade Mix Calculator",
    "path": "/analytics/grade-mix-calculator",
    "tab": "reverse",
    "find": "What should I buy?"
  },
  {
    "id": "tab:/analytics/grade-mix-calculator:forward",
    "kind": "tab",
    "name": "What will I get?",
    "page": "Grade Mix Calculator",
    "path": "/analytics/grade-mix-calculator",
    "tab": "forward",
    "find": "What will I get?"
  },
  {
    "id": "widget:/analytics/grade-mix-calculator:expected-output",
    "kind": "widget",
    "name": "Expected output",
    "page": "Grade Mix Calculator",
    "path": "/analytics/grade-mix-calculator",
    "find": "Expected output"
  },
  {
    "id": "widget:/analytics/grade-mix-calculator:purchase-lines",
    "kind": "widget",
    "name": "Purchase lines",
    "page": "Grade Mix Calculator",
    "path": "/analytics/grade-mix-calculator",
    "find": "Purchase lines"
  },
  {
    "id": "widget:/analytics/lot-board:period-trends",
    "kind": "widget",
    "name": "Period Trends",
    "page": "Lot Board",
    "path": "/analytics/lot-board",
    "find": "Period Trends"
  },
  {
    "id": "widget:/analytics/lot-lifecycle:lifecycle-states",
    "kind": "widget",
    "name": "Lifecycle States",
    "page": "Lot Lifecycle",
    "path": "/analytics/lot-lifecycle",
    "find": "Lifecycle States"
  },
  {
    "id": "widget:/analytics/lot-pnl:production-days-realization-estimated",
    "kind": "widget",
    "name": "Production Days (realization estimated)",
    "page": "Lot Pnl",
    "path": "/analytics/lot-pnl",
    "find": "Production Days (realization estimated)"
  },
  {
    "id": "widget:/analytics/lot-pnl:stage-waterfall",
    "kind": "widget",
    "name": "Stage Waterfall",
    "page": "Lot Pnl",
    "path": "/analytics/lot-pnl",
    "find": "Stage Waterfall"
  },
  {
    "id": "widget:/analytics/margin-command-center:1-purchase-margin-guard",
    "kind": "widget",
    "name": "1. Purchase Margin Guard",
    "page": "Margin Command Center",
    "path": "/analytics/margin-command-center",
    "find": "1. Purchase Margin Guard"
  },
  {
    "id": "widget:/analytics/margin-command-center:2-early-headless-control",
    "kind": "widget",
    "name": "2. Early Headless Control",
    "page": "Margin Command Center",
    "path": "/analytics/margin-command-center",
    "find": "2. Early Headless Control"
  },
  {
    "id": "widget:/analytics/margin-command-center:floor-actions-that-must-close",
    "kind": "widget",
    "name": "Floor actions that must close",
    "page": "Margin Command Center",
    "path": "/analytics/margin-command-center",
    "find": "Floor actions that must close"
  },
  {
    "id": "widget:/analytics/margin-command-center:recent-purchase-decisions",
    "kind": "widget",
    "name": "Recent purchase decisions",
    "page": "Margin Command Center",
    "path": "/analytics/margin-command-center",
    "find": "Recent purchase decisions"
  },
  {
    "id": "tab:/analytics/price-benchmarking:realised",
    "kind": "tab",
    "name": "Realised & Benchmark",
    "page": "Price Benchmarking",
    "path": "/analytics/price-benchmarking",
    "tab": "realised",
    "find": "Realised & Benchmark"
  },
  {
    "id": "tab:/analytics/price-benchmarking:references",
    "kind": "tab",
    "name": "Reference Prices",
    "page": "Price Benchmarking",
    "path": "/analytics/price-benchmarking",
    "tab": "references",
    "find": "Reference Prices"
  },
  {
    "id": "widget:/analytics/price-benchmarking:add-reference-price",
    "kind": "widget",
    "name": "Add reference price",
    "page": "Price Benchmarking",
    "path": "/analytics/price-benchmarking",
    "find": "Add reference price"
  },
  {
    "id": "widget:/analytics/price-benchmarking:realised-export-prices-your-orders",
    "kind": "widget",
    "name": "Realised export prices (your orders)",
    "page": "Price Benchmarking",
    "path": "/analytics/price-benchmarking",
    "find": "Realised export prices (your orders)"
  },
  {
    "id": "widget:/analytics/price-benchmarking:reference-prices",
    "kind": "widget",
    "name": "Reference prices",
    "page": "Price Benchmarking",
    "path": "/analytics/price-benchmarking",
    "find": "Reference prices"
  },
  {
    "id": "tab:/analytics/purchase-vs-production:saved",
    "kind": "tab",
    "name": "Saved statements",
    "page": "Purchase Vs Production",
    "path": "/analytics/purchase-vs-production",
    "tab": "saved",
    "find": "Saved statements"
  },
  {
    "id": "tab:/analytics/purchase-vs-production:sheet",
    "kind": "tab",
    "name": "Statement",
    "page": "Purchase Vs Production",
    "path": "/analytics/purchase-vs-production",
    "tab": "sheet",
    "find": "Statement"
  },
  {
    "id": "widget:/analytics/reverse-rm:order-details",
    "kind": "widget",
    "name": "Order Details",
    "page": "Reverse Calculator",
    "path": "/analytics/reverse-rm",
    "find": "Order Details"
  },
  {
    "id": "widget:/analytics/reverse-rm:yield-cascade-estimate-gross-order-net-defect",
    "kind": "widget",
    "name": "Yield Cascade (estimate) · gross order → net · defect %",
    "page": "Reverse Calculator",
    "path": "/analytics/reverse-rm",
    "find": "Yield Cascade (estimate) · gross order → net · defect %"
  },
  {
    "id": "widget:/analytics/rm-requirement:purchase-plan-estimate",
    "kind": "widget",
    "name": "Purchase Plan (estimate)",
    "page": "Rm Requirement",
    "path": "/analytics/rm-requirement",
    "find": "Purchase Plan (estimate)"
  },
  {
    "id": "widget:/analytics/spec-masters:freezing-types",
    "kind": "widget",
    "name": "Freezing Types",
    "page": "Spec Masters",
    "path": "/analytics/spec-masters",
    "find": "Freezing Types"
  },
  {
    "id": "widget:/analytics/spec-masters:treatments",
    "kind": "widget",
    "name": "Treatments",
    "page": "Spec Masters",
    "path": "/analytics/spec-masters",
    "find": "Treatments"
  },
  {
    "id": "widget:/analytics/yield-accuracy:biggest-shortfalls",
    "kind": "widget",
    "name": "Biggest shortfalls",
    "page": "Yield Accuracy",
    "path": "/analytics/yield-accuracy",
    "find": "Biggest shortfalls"
  },
  {
    "id": "widget:/analytics/yield-accuracy:error-by-month",
    "kind": "widget",
    "name": "Error by month",
    "page": "Yield Accuracy",
    "path": "/analytics/yield-accuracy",
    "find": "Error by month"
  },
  {
    "id": "widget:/analytics/yield-accuracy:model",
    "kind": "widget",
    "name": "Model",
    "page": "Yield Accuracy",
    "path": "/analytics/yield-accuracy",
    "find": "Model"
  },
  {
    "id": "widget:/analytics/yield-accuracy:variance-by-farmer-agent",
    "kind": "widget",
    "name": "Variance by farmer / agent",
    "page": "Yield Accuracy",
    "path": "/analytics/yield-accuracy",
    "find": "Variance by farmer / agent"
  },
  {
    "id": "widget:/analytics/yield-accuracy:where-production-days-landed",
    "kind": "widget",
    "name": "Where production days landed",
    "page": "Yield Accuracy",
    "path": "/analytics/yield-accuracy",
    "find": "Where production days landed"
  },
  {
    "id": "widget:/batch-pipeline:new-batch-pipeline",
    "kind": "widget",
    "name": "New Batch Pipeline",
    "page": "Batch Pipeline",
    "path": "/batch-pipeline",
    "find": "New Batch Pipeline"
  },
  {
    "id": "widget:/batch-pipeline:weight-waterfall",
    "kind": "widget",
    "name": "Weight Waterfall",
    "page": "Batch Pipeline",
    "path": "/batch-pipeline",
    "find": "Weight Waterfall"
  },
  {
    "id": "tab:/clients/intelligence:profile",
    "kind": "tab",
    "name": "Buyer 360",
    "page": "Client Intelligence",
    "path": "/clients/intelligence",
    "tab": "profile",
    "find": "Buyer 360"
  },
  {
    "id": "tab:/clients/intelligence:watchlist",
    "kind": "tab",
    "name": "Churn Watchlist",
    "page": "Client Intelligence",
    "path": "/clients/intelligence",
    "tab": "watchlist",
    "find": "Churn Watchlist"
  },
  {
    "id": "tab:/clients/intelligence:rankings",
    "kind": "tab",
    "name": "Rankings",
    "page": "Client Intelligence",
    "path": "/clients/intelligence",
    "tab": "rankings",
    "find": "Rankings"
  },
  {
    "id": "tab:/clients/intelligence:relationship",
    "kind": "tab",
    "name": "Relationship",
    "page": "Client Intelligence",
    "path": "/clients/intelligence",
    "tab": "relationship",
    "find": "Relationship"
  },
  {
    "id": "widget:/clients/intelligence:avg-realised-by-spec-lb",
    "kind": "widget",
    "name": "Avg realised by spec ($/lb)",
    "page": "Client Intelligence",
    "path": "/clients/intelligence",
    "find": "Avg realised by spec ($/lb)"
  },
  {
    "id": "widget:/clients/intelligence:bottom-movers",
    "kind": "widget",
    "name": "Bottom movers",
    "page": "Client Intelligence",
    "path": "/clients/intelligence",
    "find": "Bottom movers"
  },
  {
    "id": "widget:/clients/intelligence:interaction-timeline",
    "kind": "widget",
    "name": "Interaction timeline",
    "page": "Client Intelligence",
    "path": "/clients/intelligence",
    "find": "Interaction timeline"
  },
  {
    "id": "widget:/clients/intelligence:log-interaction",
    "kind": "widget",
    "name": "Log interaction",
    "page": "Client Intelligence",
    "path": "/clients/intelligence",
    "find": "Log interaction"
  },
  {
    "id": "widget:/clients/intelligence:order-vs-price-history-margin-erosion",
    "kind": "widget",
    "name": "Order-vs-price history (margin erosion)",
    "page": "Client Intelligence",
    "path": "/clients/intelligence",
    "find": "Order-vs-price history (margin erosion)"
  },
  {
    "id": "widget:/clients/intelligence:relationship-health-100",
    "kind": "widget",
    "name": "Relationship health /100 ·",
    "page": "Client Intelligence",
    "path": "/clients/intelligence",
    "find": "Relationship health /100 ·"
  },
  {
    "id": "widget:/clients/intelligence:top-contributors",
    "kind": "widget",
    "name": "Top contributors",
    "page": "Client Intelligence",
    "path": "/clients/intelligence",
    "find": "Top contributors"
  },
  {
    "id": "tab:/cold-storage:allocated-stock",
    "kind": "tab",
    "name": "Allocated Stock",
    "page": "Cold Storage",
    "path": "/cold-storage",
    "tab": "allocated-stock",
    "find": "Allocated Stock"
  },
  {
    "id": "tab:/cold-storage:inventory",
    "kind": "tab",
    "name": "Available Stock",
    "page": "Cold Storage",
    "path": "/cold-storage",
    "tab": "inventory",
    "find": "Available Stock"
  },
  {
    "id": "tab:/cold-storage:utilization",
    "kind": "tab",
    "name": "Freezer Utilization",
    "page": "Cold Storage",
    "path": "/cold-storage",
    "tab": "utilization",
    "find": "Freezer Utilization"
  },
  {
    "id": "tab:/cold-storage:insights",
    "kind": "tab",
    "name": "Insights",
    "page": "Cold Storage",
    "path": "/cold-storage",
    "tab": "insights",
    "find": "Insights"
  },
  {
    "id": "tab:/cold-storage:picklist",
    "kind": "tab",
    "name": "Pick List",
    "page": "Cold Storage",
    "path": "/cold-storage",
    "tab": "picklist",
    "find": "Pick List"
  },
  {
    "id": "tab:/cold-storage:sold-stock",
    "kind": "tab",
    "name": "Sold Stock",
    "page": "Cold Storage",
    "path": "/cold-storage",
    "tab": "sold-stock",
    "find": "Sold Stock"
  },
  {
    "id": "tab:/cold-storage:map",
    "kind": "tab",
    "name": "Store Map",
    "page": "Cold Storage",
    "path": "/cold-storage",
    "tab": "map",
    "find": "Store Map"
  },
  {
    "id": "tab:/cold-storage:store",
    "kind": "tab",
    "name": "Store View",
    "page": "Cold Storage",
    "path": "/cold-storage",
    "tab": "store",
    "find": "Store View"
  },
  {
    "id": "tab:/cold-storage:temperature",
    "kind": "tab",
    "name": "Temperature Logs",
    "page": "Cold Storage",
    "path": "/cold-storage",
    "tab": "temperature",
    "find": "Temperature Logs"
  },
  {
    "id": "widget:/cold-storage:ageing",
    "kind": "widget",
    "name": "Ageing",
    "page": "Cold Storage",
    "path": "/cold-storage",
    "find": "Ageing"
  },
  {
    "id": "widget:/cold-storage:cold-storage-layout",
    "kind": "widget",
    "name": "Cold Storage Layout",
    "page": "Cold Storage",
    "path": "/cold-storage",
    "find": "Cold Storage Layout"
  },
  {
    "id": "widget:/cold-storage:non-booked-stock-available-now",
    "kind": "widget",
    "name": "Non-booked Stock Available Now",
    "page": "Cold Storage",
    "path": "/cold-storage",
    "find": "Non-booked Stock Available Now"
  },
  {
    "id": "widget:/cold-storage:order-fulfilment",
    "kind": "widget",
    "name": "Order fulfilment",
    "page": "Cold Storage",
    "path": "/cold-storage",
    "find": "Order fulfilment"
  },
  {
    "id": "widget:/cold-storage:per-chamber-fill",
    "kind": "widget",
    "name": "Per-chamber fill",
    "page": "Cold Storage",
    "path": "/cold-storage",
    "find": "Per-chamber fill"
  },
  {
    "id": "widget:/cold-storage:pick-these-next",
    "kind": "widget",
    "name": "Pick these next ·",
    "page": "Cold Storage",
    "path": "/cold-storage",
    "find": "Pick these next ·"
  },
  {
    "id": "widget:/cold-storage:received-not-placed",
    "kind": "widget",
    "name": "Received, not placed",
    "page": "Cold Storage",
    "path": "/cold-storage",
    "find": "Received, not placed"
  },
  {
    "id": "widget:/cold-storage:stock-availability-species-form-grade-count",
    "kind": "widget",
    "name": "Stock Availability — Species / Form / Grade / Count",
    "page": "Cold Storage",
    "path": "/cold-storage",
    "find": "Stock Availability — Species / Form / Grade / Count"
  },
  {
    "id": "widget:/cold-storage:stock-mix",
    "kind": "widget",
    "name": "Stock mix",
    "page": "Cold Storage",
    "path": "/cold-storage",
    "find": "Stock mix"
  },
  {
    "id": "widget:/cold-storage:stock-waiting-to-receive",
    "kind": "widget",
    "name": "Stock Waiting to Receive",
    "page": "Cold Storage",
    "path": "/cold-storage",
    "find": "Stock Waiting to Receive"
  },
  {
    "id": "widget:/cold-storage:temperature-monitoring",
    "kind": "widget",
    "name": "Temperature Monitoring",
    "page": "Cold Storage",
    "path": "/cold-storage",
    "find": "Temperature Monitoring"
  },
  {
    "id": "widget:/cold-storage:temperature-trend",
    "kind": "widget",
    "name": "Temperature Trend",
    "page": "Cold Storage",
    "path": "/cold-storage",
    "find": "Temperature Trend"
  },
  {
    "id": "widget:/cold-storage/intake:order-fulfilment",
    "kind": "widget",
    "name": "Order fulfilment",
    "page": "Cold Store Intake",
    "path": "/cold-storage/intake",
    "find": "Order fulfilment"
  },
  {
    "id": "widget:/cold-storage/intake:per-chamber-fill",
    "kind": "widget",
    "name": "Per-chamber fill",
    "page": "Cold Store Intake",
    "path": "/cold-storage/intake",
    "find": "Per-chamber fill"
  },
  {
    "id": "widget:/cold-storage/intake:pick-these-next",
    "kind": "widget",
    "name": "Pick these next ·",
    "page": "Cold Store Intake",
    "path": "/cold-storage/intake",
    "find": "Pick these next ·"
  },
  {
    "id": "widget:/cold-storage/intake:received-not-placed",
    "kind": "widget",
    "name": "Received, not placed",
    "page": "Cold Store Intake",
    "path": "/cold-storage/intake",
    "find": "Received, not placed"
  },
  {
    "id": "widget:/cold-storage/intake:stock-waiting-to-receive",
    "kind": "widget",
    "name": "Stock Waiting to Receive",
    "page": "Cold Store Intake",
    "path": "/cold-storage/intake",
    "find": "Stock Waiting to Receive"
  },
  {
    "id": "widget:/cold-storage/intake:temperature-monitoring",
    "kind": "widget",
    "name": "Temperature Monitoring",
    "page": "Cold Store Intake",
    "path": "/cold-storage/intake",
    "find": "Temperature Monitoring"
  },
  {
    "id": "widget:/cold-storage/intake:temperature-trend",
    "kind": "widget",
    "name": "Temperature Trend",
    "page": "Cold Store Intake",
    "path": "/cold-storage/intake",
    "find": "Temperature Trend"
  },
  {
    "id": "widget:/cold-storage/masters:cold-storage-layout",
    "kind": "widget",
    "name": "Cold Storage Layout",
    "page": "Cold Storage Masters",
    "path": "/cold-storage/masters",
    "find": "Cold Storage Layout"
  },
  {
    "id": "widget:/cold-storage/masters:non-booked-stock-available-now",
    "kind": "widget",
    "name": "Non-booked Stock Available Now",
    "page": "Cold Storage Masters",
    "path": "/cold-storage/masters",
    "find": "Non-booked Stock Available Now"
  },
  {
    "id": "tab:/cold-storage/movements:outflow",
    "kind": "tab",
    "name": "Gate",
    "page": "Store Movements",
    "path": "/cold-storage/movements",
    "tab": "outflow",
    "find": "Gate"
  },
  {
    "id": "tab:/cold-storage/movements:ledger",
    "kind": "tab",
    "name": "Movement Ledger",
    "page": "Store Movements",
    "path": "/cold-storage/movements",
    "tab": "ledger",
    "find": "Movement Ledger"
  },
  {
    "id": "tab:/cold-storage/movements:tools",
    "kind": "tab",
    "name": "Tools",
    "page": "Store Movements",
    "path": "/cold-storage/movements",
    "tab": "tools",
    "find": "Tools"
  },
  {
    "id": "widget:/cold-storage/movements:create-pallet-handling-unit",
    "kind": "widget",
    "name": "Create pallet / handling unit",
    "page": "Store Movements",
    "path": "/cold-storage/movements",
    "find": "Create pallet / handling unit",
    "features": [
      "palletizedColdStorage"
    ]
  },
  {
    "id": "widget:/cold-storage/movements:cycle-count-and-variance-approval",
    "kind": "widget",
    "name": "Cycle count and variance approval",
    "page": "Store Movements",
    "path": "/cold-storage/movements",
    "find": "Cycle count and variance approval",
    "features": [
      "palletizedColdStorage"
    ]
  },
  {
    "id": "widget:/cold-storage/movements:movement-ledger",
    "kind": "widget",
    "name": "Movement Ledger",
    "page": "Store Movements",
    "path": "/cold-storage/movements",
    "find": "Movement Ledger"
  },
  {
    "id": "widget:/cold-storage/movements:pallet-work-queue",
    "kind": "widget",
    "name": "Pallet work queue",
    "page": "Store Movements",
    "path": "/cold-storage/movements",
    "find": "Pallet work queue",
    "features": [
      "palletizedColdStorage"
    ]
  },
  {
    "id": "widget:/cold-storage/movements:reserve-fefo-stock-for-order",
    "kind": "widget",
    "name": "Reserve FEFO stock for order",
    "page": "Store Movements",
    "path": "/cold-storage/movements",
    "find": "Reserve FEFO stock for order",
    "features": [
      "palletizedColdStorage"
    ]
  },
  {
    "id": "widget:/cold-storage/movements:stock-pick-suggestions",
    "kind": "widget",
    "name": "Stock Pick Suggestions",
    "page": "Store Movements",
    "path": "/cold-storage/movements",
    "find": "Stock Pick Suggestions",
    "features": [
      "fifoManagement"
    ]
  },
  {
    "id": "widget:/data-migration:cut-over",
    "kind": "widget",
    "name": "Cut-over",
    "page": "Data Migration",
    "path": "/data-migration",
    "find": "Cut-over"
  },
  {
    "id": "widget:/data-migration:imports",
    "kind": "widget",
    "name": "Imports",
    "page": "Data Migration",
    "path": "/data-migration",
    "find": "Imports"
  },
  {
    "id": "widget:/data-migration:opening-balances-on-record-fy",
    "kind": "widget",
    "name": "Opening balances on record — FY",
    "page": "Data Migration",
    "path": "/data-migration",
    "find": "Opening balances on record — FY"
  },
  {
    "id": "widget:/data-migration:step-1-parties-opening-balances",
    "kind": "widget",
    "name": "Step 1 — Parties & opening balances",
    "page": "Data Migration",
    "path": "/data-migration",
    "find": "Step 1 — Parties & opening balances"
  },
  {
    "id": "widget:/docs:attach-a-walkthrough",
    "kind": "widget",
    "name": "Attach a walkthrough",
    "page": "Docs",
    "path": "/docs",
    "find": "Attach a walkthrough"
  },
  {
    "id": "widget:/docs:before-you-start",
    "kind": "widget",
    "name": "Before you start",
    "page": "Docs",
    "path": "/docs",
    "find": "Before you start"
  },
  {
    "id": "widget:/docs:documentation-health",
    "kind": "widget",
    "name": "Documentation health",
    "page": "Docs",
    "path": "/docs",
    "find": "Documentation health"
  },
  {
    "id": "widget:/docs:questions-and-steps",
    "kind": "widget",
    "name": "Questions and steps",
    "page": "Docs",
    "path": "/docs",
    "find": "Questions and steps"
  },
  {
    "id": "widget:/docs:screen-captures",
    "kind": "widget",
    "name": "Screen captures",
    "page": "Docs",
    "path": "/docs",
    "find": "Screen captures"
  },
  {
    "id": "widget:/docs:steps",
    "kind": "widget",
    "name": "Steps",
    "page": "Docs",
    "path": "/docs",
    "find": "Steps"
  },
  {
    "id": "widget:/docs:watch-or-listen-then-follow-the-steps",
    "kind": "widget",
    "name": "Watch or listen, then follow the steps",
    "page": "Docs",
    "path": "/docs",
    "find": "Watch or listen, then follow the steps"
  },
  {
    "id": "widget:/finished-goods:finished-goods-inventory",
    "kind": "widget",
    "name": "Finished Goods Inventory",
    "page": "Finished Goods",
    "path": "/finished-goods",
    "find": "Finished Goods Inventory"
  },
  {
    "id": "widget:/finished-goods:product",
    "kind": "widget",
    "name": "Product",
    "page": "Finished Goods",
    "path": "/finished-goods",
    "find": "Product"
  },
  {
    "id": "widget:/finished-goods:qc-documents-certificates",
    "kind": "widget",
    "name": "QC documents & certificates",
    "page": "Finished Goods",
    "path": "/finished-goods",
    "find": "QC documents & certificates"
  },
  {
    "id": "widget:/finished-goods:qc-verdict",
    "kind": "widget",
    "name": "QC verdict",
    "page": "Finished Goods",
    "path": "/finished-goods",
    "find": "QC verdict"
  },
  {
    "id": "widget:/finished-goods:stock-position",
    "kind": "widget",
    "name": "Stock position",
    "page": "Finished Goods",
    "path": "/finished-goods",
    "find": "Stock position"
  },
  {
    "id": "widget:/hr/payroll:payslips-to",
    "kind": "widget",
    "name": "Payslips — to",
    "page": "Payroll",
    "path": "/hr/payroll",
    "find": "Payslips — to"
  },
  {
    "id": "tab:/inventory:buy",
    "kind": "tab",
    "name": "Buy & receive",
    "page": "Inventory",
    "path": "/inventory",
    "tabParam": "tab",
    "tab": "buy",
    "find": "Buy & receive"
  },
  {
    "id": "tab:/inventory:costing",
    "kind": "tab",
    "name": "Costing",
    "page": "Inventory",
    "path": "/inventory",
    "tabParam": "tab",
    "tab": "costing",
    "find": "Costing"
  },
  {
    "id": "tab:/inventory:out",
    "kind": "tab",
    "name": "Move out",
    "page": "Inventory",
    "path": "/inventory",
    "tabParam": "tab",
    "tab": "out",
    "find": "Move out"
  },
  {
    "id": "tab:/inventory:stock",
    "kind": "tab",
    "name": "Stock",
    "page": "Inventory",
    "path": "/inventory",
    "tabParam": "tab",
    "tab": "stock",
    "find": "Stock"
  },
  {
    "id": "tab:/inventory:ledgers",
    "kind": "tab",
    "name": "Vendor ledgers",
    "page": "Inventory",
    "path": "/inventory",
    "tabParam": "tab",
    "tab": "ledgers",
    "find": "Vendor ledgers"
  },
  {
    "id": "tab:/inventory:vendors",
    "kind": "tab",
    "name": "Vendors",
    "page": "Inventory",
    "path": "/inventory",
    "tabParam": "tab",
    "tab": "vendors",
    "find": "Vendors"
  },
  {
    "id": "widget:/inventory:indents",
    "kind": "widget",
    "name": "Indents",
    "page": "Inventory",
    "path": "/inventory",
    "find": "Indents"
  },
  {
    "id": "widget:/inventory:my-signature",
    "kind": "widget",
    "name": "My signature",
    "page": "Inventory",
    "path": "/inventory",
    "find": "My signature"
  },
  {
    "id": "widget:/inventory:packing-cost-per-carton",
    "kind": "widget",
    "name": "Packing cost per carton",
    "page": "Inventory",
    "path": "/inventory",
    "find": "Packing cost per carton"
  },
  {
    "id": "widget:/inventory:purchase-order-settings",
    "kind": "widget",
    "name": "Purchase order settings",
    "page": "Inventory",
    "path": "/inventory",
    "find": "Purchase order settings"
  },
  {
    "id": "widget:/inventory:quotation-comparison",
    "kind": "widget",
    "name": "Quotation Comparison",
    "page": "Inventory",
    "path": "/inventory",
    "find": "Quotation Comparison"
  },
  {
    "id": "widget:/inventory:stock-register",
    "kind": "widget",
    "name": "Stock register",
    "page": "Inventory",
    "path": "/inventory",
    "find": "Stock register"
  },
  {
    "id": "widget:/inventory:stock-value-on-hand",
    "kind": "widget",
    "name": "Stock value on hand",
    "page": "Inventory",
    "path": "/inventory",
    "find": "Stock value on hand"
  },
  {
    "id": "widget:/inventory:store-consumption",
    "kind": "widget",
    "name": "Store consumption",
    "page": "Inventory",
    "path": "/inventory",
    "find": "Store consumption"
  },
  {
    "id": "widget:/inventory:vendor-ledgers",
    "kind": "widget",
    "name": "Vendor ledgers",
    "page": "Inventory",
    "path": "/inventory",
    "find": "Vendor ledgers"
  },
  {
    "id": "widget:/inventory:vendors",
    "kind": "widget",
    "name": "Vendors",
    "page": "Inventory",
    "path": "/inventory",
    "find": "Vendors"
  },
  {
    "id": "widget:/masters:benchmarks",
    "kind": "widget",
    "name": "Benchmarks",
    "page": "Masters",
    "path": "/masters",
    "find": "Benchmarks"
  },
  {
    "id": "widget:/masters:checkpoint-gates",
    "kind": "widget",
    "name": "Checkpoint Gates",
    "page": "Masters",
    "path": "/masters",
    "find": "Checkpoint Gates"
  },
  {
    "id": "widget:/masters:company-wide",
    "kind": "widget",
    "name": "Company-wide",
    "page": "Masters",
    "path": "/masters",
    "find": "Company-wide"
  },
  {
    "id": "widget:/masters:exceptions-by-species-and-product-form",
    "kind": "widget",
    "name": "Exceptions by species and product form",
    "page": "Masters",
    "path": "/masters",
    "find": "Exceptions by species and product form"
  },
  {
    "id": "widget:/masters:expected-grade-mix",
    "kind": "widget",
    "name": "Expected Grade Mix",
    "page": "Masters",
    "path": "/masters",
    "find": "Expected Grade Mix"
  },
  {
    "id": "widget:/masters:form-yield-standards",
    "kind": "widget",
    "name": "Form Yield Standards",
    "page": "Masters",
    "path": "/masters",
    "find": "Form Yield Standards"
  },
  {
    "id": "widget:/masters:freezing-types",
    "kind": "widget",
    "name": "Freezing Types",
    "page": "Masters",
    "path": "/masters",
    "find": "Freezing Types"
  },
  {
    "id": "widget:/masters:freshness-and-cold-store",
    "kind": "widget",
    "name": "Freshness and cold store",
    "page": "Masters",
    "path": "/masters",
    "find": "Freshness and cold store"
  },
  {
    "id": "widget:/masters:per-stage",
    "kind": "widget",
    "name": "Per stage",
    "page": "Masters",
    "path": "/masters",
    "find": "Per stage"
  },
  {
    "id": "widget:/masters:purchase-vs-production",
    "kind": "widget",
    "name": "Purchase vs Production",
    "page": "Masters",
    "path": "/masters",
    "find": "Purchase vs Production"
  },
  {
    "id": "widget:/masters:recipients",
    "kind": "widget",
    "name": "Recipients",
    "page": "Masters",
    "path": "/masters",
    "find": "Recipients"
  },
  {
    "id": "widget:/masters:risky-actions",
    "kind": "widget",
    "name": "Risky actions",
    "page": "Masters",
    "path": "/masters",
    "find": "Risky actions"
  },
  {
    "id": "widget:/masters:sale-rate-master",
    "kind": "widget",
    "name": "Sale Rate Master",
    "page": "Masters",
    "path": "/masters",
    "find": "Sale Rate Master"
  },
  {
    "id": "widget:/masters:shifts-and-working-days",
    "kind": "widget",
    "name": "Shifts and working days",
    "page": "Masters",
    "path": "/masters",
    "find": "Shifts and working days"
  },
  {
    "id": "widget:/masters:stage-throughput",
    "kind": "widget",
    "name": "Stage throughput",
    "page": "Masters",
    "path": "/masters",
    "find": "Stage throughput"
  },
  {
    "id": "widget:/masters:tests",
    "kind": "widget",
    "name": "Tests",
    "page": "Masters",
    "path": "/masters",
    "find": "Tests"
  },
  {
    "id": "widget:/masters:treatments",
    "kind": "widget",
    "name": "Treatments",
    "page": "Masters",
    "path": "/masters",
    "find": "Treatments"
  },
  {
    "id": "widget:/masters:waiting-between-stages",
    "kind": "widget",
    "name": "Waiting between stages",
    "page": "Masters",
    "path": "/masters",
    "find": "Waiting between stages"
  },
  {
    "id": "widget:/masters:who-can-see-prices-of-roles-reload",
    "kind": "widget",
    "name": "Who Can See Prices of roles Reload",
    "page": "Masters",
    "path": "/masters",
    "find": "Who Can See Prices of roles Reload"
  },
  {
    "id": "tab:/merchants:challans",
    "kind": "tab",
    "name": "Delivery Challans",
    "page": "Merchant Hub",
    "path": "/merchants",
    "tab": "challans",
    "find": "Delivery Challans"
  },
  {
    "id": "tab:/merchants:invoices",
    "kind": "tab",
    "name": "Job Invoices",
    "page": "Merchant Hub",
    "path": "/merchants",
    "tab": "invoices",
    "find": "Job Invoices"
  },
  {
    "id": "tab:/merchants:rates",
    "kind": "tab",
    "name": "Rate Cards",
    "page": "Merchant Hub",
    "path": "/merchants",
    "tab": "rates",
    "find": "Rate Cards"
  },
  {
    "id": "tab:/merchants:stock",
    "kind": "tab",
    "name": "Stock in Our Chambers",
    "page": "Merchant Hub",
    "path": "/merchants",
    "tab": "stock",
    "find": "Stock in Our Chambers"
  },
  {
    "id": "widget:/merchants:delivery-challans",
    "kind": "widget",
    "name": "Delivery Challans",
    "page": "Merchant Hub",
    "path": "/merchants",
    "find": "Delivery Challans"
  },
  {
    "id": "widget:/merchants:job-work-invoices",
    "kind": "widget",
    "name": "Job Work Invoices",
    "page": "Merchant Hub",
    "path": "/merchants",
    "find": "Job Work Invoices"
  },
  {
    "id": "widget:/merchants:merchant-stock",
    "kind": "widget",
    "name": "Merchant Stock",
    "page": "Merchant Hub",
    "path": "/merchants",
    "find": "Merchant Stock"
  },
  {
    "id": "widget:/merchants:rate-cards",
    "kind": "widget",
    "name": "Rate Cards",
    "page": "Merchant Hub",
    "path": "/merchants",
    "find": "Rate Cards"
  },
  {
    "id": "widget:/merchants:work-out-a-period-s-charges",
    "kind": "widget",
    "name": "Work out a period's charges",
    "page": "Merchant Hub",
    "path": "/merchants",
    "find": "Work out a period's charges"
  },
  {
    "id": "widget:/my-change-requests:saved-to-review",
    "kind": "widget",
    "name": "Saved, to review",
    "page": "My Change Requests",
    "path": "/my-change-requests",
    "find": "Saved, to review"
  },
  {
    "id": "widget:/my-change-requests:time-approvals",
    "kind": "widget",
    "name": "Time approvals",
    "page": "My Change Requests",
    "path": "/my-change-requests",
    "find": "Time approvals"
  },
  {
    "id": "widget:/my-change-requests:waiting-for-your-approval",
    "kind": "widget",
    "name": "Waiting for your approval",
    "page": "My Change Requests",
    "path": "/my-change-requests",
    "find": "Waiting for your approval"
  },
  {
    "id": "tab:/parties:agents",
    "kind": "tab",
    "name": "Agents",
    "page": "Parties",
    "path": "/parties",
    "tabParam": "tab",
    "tab": "agents",
    "find": "Agents"
  },
  {
    "id": "tab:/parties:graders",
    "kind": "tab",
    "name": "Graders",
    "page": "Parties",
    "path": "/parties",
    "tabParam": "tab",
    "tab": "graders",
    "find": "Graders"
  },
  {
    "id": "tab:/parties:parties",
    "kind": "tab",
    "name": "Parties",
    "page": "Parties",
    "path": "/parties",
    "tabParam": "tab",
    "tab": "parties",
    "find": "Parties"
  },
  {
    "id": "tab:/parties:ledger",
    "kind": "tab",
    "name": "Party Ledger",
    "page": "Parties",
    "path": "/parties",
    "tabParam": "tab",
    "tab": "ledger",
    "find": "Party Ledger"
  },
  {
    "id": "widget:/parties:graders",
    "kind": "widget",
    "name": "Graders",
    "page": "Parties",
    "path": "/parties",
    "find": "Graders"
  },
  {
    "id": "widget:/parties:parties",
    "kind": "widget",
    "name": "Parties",
    "page": "Parties",
    "path": "/parties",
    "find": "Parties"
  },
  {
    "id": "widget:/parties:parties-getting-away-90-day-drop",
    "kind": "widget",
    "name": "Parties Getting Away (90-day drop)",
    "page": "Parties",
    "path": "/parties",
    "find": "Parties Getting Away (90-day drop)"
  },
  {
    "id": "widget:/parties:risk",
    "kind": "widget",
    "name": "Risk -",
    "page": "Parties",
    "path": "/parties",
    "find": "Risk -"
  },
  {
    "id": "widget:/parties:risk-timeline",
    "kind": "widget",
    "name": "Risk Timeline",
    "page": "Parties",
    "path": "/parties",
    "find": "Risk Timeline"
  },
  {
    "id": "widget:/parties:top-performing-parties-fy-kg",
    "kind": "widget",
    "name": "Top Performing Parties (FY KG)",
    "page": "Parties",
    "path": "/parties",
    "find": "Top Performing Parties (FY KG)"
  },
  {
    "id": "widget:/preprocessing:count-grading",
    "kind": "widget",
    "name": "Count Grading",
    "page": "Pre Processing",
    "path": "/preprocessing",
    "find": "Count Grading"
  },
  {
    "id": "widget:/preprocessing:defects-per-lot",
    "kind": "widget",
    "name": "Defects (per lot)",
    "page": "Pre Processing",
    "path": "/preprocessing",
    "find": "Defects (per lot)"
  },
  {
    "id": "widget:/preprocessing:labour-entries",
    "kind": "widget",
    "name": "Labour Entries",
    "page": "Pre Processing",
    "path": "/preprocessing",
    "find": "Labour Entries"
  },
  {
    "id": "widget:/preprocessing:lot-pooling",
    "kind": "widget",
    "name": "Lot Pooling",
    "page": "Pre Processing",
    "path": "/preprocessing",
    "find": "Lot Pooling"
  },
  {
    "id": "widget:/preprocessing:preprocessing-batches",
    "kind": "widget",
    "name": "Preprocessing Batches",
    "page": "Pre Processing",
    "path": "/preprocessing",
    "find": "Preprocessing Batches"
  },
  {
    "id": "widget:/preprocessing:workers",
    "kind": "widget",
    "name": "Workers",
    "page": "Pre Processing",
    "path": "/preprocessing",
    "find": "Workers"
  },
  {
    "id": "widget:/preprocessing/analysis-report-template:columns-drag-to-reorder-rename-toggle",
    "kind": "widget",
    "name": "Columns (drag to reorder, rename, toggle)",
    "page": "Analysis Report Template",
    "path": "/preprocessing/analysis-report-template",
    "find": "Columns (drag to reorder, rename, toggle)"
  },
  {
    "id": "widget:/preprocessing/analysis-report-template:header-text",
    "kind": "widget",
    "name": "Header Text",
    "page": "Analysis Report Template",
    "path": "/preprocessing/analysis-report-template",
    "find": "Header Text"
  },
  {
    "id": "widget:/preprocessing/analysis-report-template:live-preview",
    "kind": "widget",
    "name": "Live Preview",
    "page": "Analysis Report Template",
    "path": "/preprocessing/analysis-report-template",
    "find": "Live Preview"
  },
  {
    "id": "widget:/preprocessing/defect-masters:defect-types",
    "kind": "widget",
    "name": "Defect Types",
    "page": "Defect Masters",
    "path": "/preprocessing/defect-masters",
    "find": "Defect Types"
  },
  {
    "id": "widget:/preprocessing/floor-balance:balance-by",
    "kind": "widget",
    "name": "Balance by",
    "page": "Floor Balance",
    "path": "/preprocessing/floor-balance",
    "find": "Balance by"
  },
  {
    "id": "widget:/preprocessing/floor-balance:filters",
    "kind": "widget",
    "name": "Filters",
    "page": "Floor Balance",
    "path": "/preprocessing/floor-balance",
    "find": "Filters"
  },
  {
    "id": "widget:/preprocessing/home:continue-a-lot",
    "kind": "widget",
    "name": "Continue a lot",
    "page": "Pre Processing Home",
    "path": "/preprocessing/home",
    "find": "Continue a lot"
  },
  {
    "id": "widget:/preprocessing/home:lots-by-stage",
    "kind": "widget",
    "name": "Lots by stage",
    "page": "Pre Processing Home",
    "path": "/preprocessing/home",
    "find": "Lots by stage"
  },
  {
    "id": "widget:/preprocessing/lot-check:balance-by",
    "kind": "widget",
    "name": "Balance by",
    "page": "Phase Reconcile",
    "path": "/preprocessing/lot-check",
    "find": "Balance by"
  },
  {
    "id": "widget:/preprocessing/lot-check:filters",
    "kind": "widget",
    "name": "Filters",
    "page": "Phase Reconcile",
    "path": "/preprocessing/lot-check",
    "find": "Filters"
  },
  {
    "id": "tab:/preprocessing/masters:analysis-report",
    "kind": "tab",
    "name": "Analysis Report Template",
    "page": "Pre Production Masters",
    "path": "/preprocessing/masters",
    "tab": "analysis-report",
    "find": "Analysis Report Template"
  },
  {
    "id": "tab:/preprocessing/masters:defects",
    "kind": "tab",
    "name": "Defect Masters",
    "page": "Pre Production Masters",
    "path": "/preprocessing/masters",
    "tab": "defects",
    "find": "Defect Masters"
  },
  {
    "id": "tab:/preprocessing/masters:fixed-yield",
    "kind": "tab",
    "name": "Fixed Yield by Count",
    "page": "Pre Production Masters",
    "path": "/preprocessing/masters",
    "tab": "fixed-yield",
    "find": "Fixed Yield by Count"
  },
  {
    "id": "tab:/preprocessing/masters:material-condition",
    "kind": "tab",
    "name": "Material Condition",
    "page": "Pre Production Masters",
    "path": "/preprocessing/masters",
    "tab": "material-condition",
    "find": "Material Condition"
  },
  {
    "id": "tab:/preprocessing/masters:size-grades",
    "kind": "tab",
    "name": "Size Grades",
    "page": "Pre Production Masters",
    "path": "/preprocessing/masters",
    "tab": "size-grades",
    "find": "Size Grades"
  },
  {
    "id": "widget:/preprocessing/masters:columns-drag-to-reorder-rename-toggle",
    "kind": "widget",
    "name": "Columns (drag to reorder, rename, toggle)",
    "page": "Pre Production Masters",
    "path": "/preprocessing/masters",
    "find": "Columns (drag to reorder, rename, toggle)"
  },
  {
    "id": "widget:/preprocessing/masters:conditions-compared",
    "kind": "widget",
    "name": "Conditions compared",
    "page": "Pre Production Masters",
    "path": "/preprocessing/masters",
    "find": "Conditions compared"
  },
  {
    "id": "widget:/preprocessing/masters:count-fixed-yield",
    "kind": "widget",
    "name": "Count → Fixed Yield",
    "page": "Pre Production Masters",
    "path": "/preprocessing/masters",
    "find": "Count → Fixed Yield"
  },
  {
    "id": "widget:/preprocessing/masters:defect-types",
    "kind": "widget",
    "name": "Defect Types",
    "page": "Pre Production Masters",
    "path": "/preprocessing/masters",
    "find": "Defect Types"
  },
  {
    "id": "widget:/preprocessing/masters:fixed-yield-by-count",
    "kind": "widget",
    "name": "Fixed Yield by Count",
    "page": "Pre Production Masters",
    "path": "/preprocessing/masters",
    "find": "Fixed Yield by Count"
  },
  {
    "id": "widget:/preprocessing/masters:header-text",
    "kind": "widget",
    "name": "Header Text",
    "page": "Pre Production Masters",
    "path": "/preprocessing/masters",
    "find": "Header Text"
  },
  {
    "id": "widget:/preprocessing/masters:live-preview",
    "kind": "widget",
    "name": "Live Preview",
    "page": "Pre Production Masters",
    "path": "/preprocessing/masters",
    "find": "Live Preview"
  },
  {
    "id": "widget:/preprocessing/masters:size-count-grades",
    "kind": "widget",
    "name": "Size / Count Grades",
    "page": "Pre Production Masters",
    "path": "/preprocessing/masters",
    "find": "Size / Count Grades"
  },
  {
    "id": "widget:/preprocessing/masters:total-defects",
    "kind": "widget",
    "name": "Total Defects",
    "page": "Pre Production Masters",
    "path": "/preprocessing/masters",
    "find": "Total Defects"
  },
  {
    "id": "widget:/preprocessing/size-grades:size-count-grades",
    "kind": "widget",
    "name": "Size / Count Grades",
    "page": "Size Grades",
    "path": "/preprocessing/size-grades",
    "find": "Size / Count Grades"
  },
  {
    "id": "tab:/production/entry:active",
    "kind": "tab",
    "name": "Active",
    "page": "Production Entry",
    "path": "/production/entry",
    "tab": "active",
    "find": "Active"
  },
  {
    "id": "tab:/production/entry:completed",
    "kind": "tab",
    "name": "Completed",
    "page": "Production Entry",
    "path": "/production/entry",
    "tab": "completed",
    "find": "Completed"
  },
  {
    "id": "widget:/production/entry:book-batches-lines",
    "kind": "widget",
    "name": "Book batches / lines",
    "page": "Production Entry",
    "path": "/production/entry",
    "find": "Book batches / lines"
  },
  {
    "id": "widget:/production/entry:detail-list",
    "kind": "widget",
    "name": "Detail List",
    "page": "Production Entry",
    "path": "/production/entry",
    "find": "Detail List"
  },
  {
    "id": "widget:/production/masters:packing-styles",
    "kind": "widget",
    "name": "Packing Styles",
    "page": "Production Masters",
    "path": "/production/masters",
    "find": "Packing Styles"
  },
  {
    "id": "widget:/production/packing-styles:packing-styles",
    "kind": "widget",
    "name": "Packing Styles",
    "page": "Packing Styles",
    "path": "/production/packing-styles",
    "find": "Packing Styles"
  },
  {
    "id": "tab:/production/workflow:active",
    "kind": "tab",
    "name": "Active",
    "page": "Production Workflow",
    "path": "/production/workflow",
    "tab": "active",
    "find": "Active"
  },
  {
    "id": "tab:/purchase-booking:whatsapp",
    "kind": "tab",
    "name": "From WhatsApp",
    "page": "Purchase Booking",
    "path": "/purchase-booking",
    "find": "From WhatsApp"
  },
  {
    "id": "tab:/purchase-booking:slips",
    "kind": "tab",
    "name": "Grader Slips",
    "page": "Purchase Booking",
    "path": "/purchase-booking",
    "find": "Grader Slips"
  },
  {
    "id": "tab:/purchase-booking:invoiced",
    "kind": "tab",
    "name": "Invoice Raised",
    "page": "Purchase Booking",
    "path": "/purchase-booking",
    "find": "Invoice Raised"
  },
  {
    "id": "tab:/purchase-booking:open",
    "kind": "tab",
    "name": "Open Bookings",
    "page": "Purchase Booking",
    "path": "/purchase-booking",
    "find": "Open Bookings"
  },
  {
    "id": "widget:/purchase-invoices:invoice-preview",
    "kind": "widget",
    "name": "Invoice Preview",
    "page": "Purchase Invoices",
    "path": "/purchase-invoices",
    "find": "Invoice Preview"
  },
  {
    "id": "widget:/purchase-invoices:invoices",
    "kind": "widget",
    "name": "Invoices",
    "page": "Purchase Invoices",
    "path": "/purchase-invoices",
    "find": "Invoices"
  },
  {
    "id": "widget:/purchase-invoices/create:create-new-party",
    "kind": "widget",
    "name": "Create New Party",
    "page": "Purchase Invoice Form",
    "path": "/purchase-invoices/create",
    "find": "Create New Party"
  },
  {
    "id": "widget:/purchase-invoices/create:office-use-not-on-the-paper-slip",
    "kind": "widget",
    "name": "Office Use not on the paper slip",
    "page": "Purchase Invoice Form",
    "path": "/purchase-invoices/create",
    "find": "Office Use not on the paper slip"
  },
  {
    "id": "widget:/purchase-risk-alerts:area-insight-filters",
    "kind": "widget",
    "name": "Area Insight Filters",
    "page": "Purchase Risk Alerts",
    "path": "/purchase-risk-alerts",
    "find": "Area Insight Filters"
  },
  {
    "id": "widget:/purchase-risk-alerts:area-ranking",
    "kind": "widget",
    "name": "Area Ranking",
    "page": "Purchase Risk Alerts",
    "path": "/purchase-risk-alerts",
    "find": "Area Ranking"
  },
  {
    "id": "widget:/purchase-risk-alerts:area-risk-insights",
    "kind": "widget",
    "name": "Area Risk Insights",
    "page": "Purchase Risk Alerts",
    "path": "/purchase-risk-alerts",
    "find": "Area Risk Insights"
  },
  {
    "id": "widget:/purchase-risk-alerts:create-risk-alert",
    "kind": "widget",
    "name": "Create Risk Alert",
    "page": "Purchase Risk Alerts",
    "path": "/purchase-risk-alerts",
    "find": "Create Risk Alert"
  },
  {
    "id": "widget:/purchase-risk-alerts:risk-alerts-master",
    "kind": "widget",
    "name": "Risk Alerts Master",
    "page": "Purchase Risk Alerts",
    "path": "/purchase-risk-alerts",
    "find": "Risk Alerts Master"
  },
  {
    "id": "widget:/qc:inspection-parameters",
    "kind": "widget",
    "name": "Inspection Parameters",
    "page": "Quality Control",
    "path": "/qc",
    "find": "Inspection Parameters"
  },
  {
    "id": "widget:/qc:qc-inspections",
    "kind": "widget",
    "name": "QC Inspections",
    "page": "Quality Control",
    "path": "/qc",
    "find": "QC Inspections"
  },
  {
    "id": "widget:/qc:stage-view",
    "kind": "widget",
    "name": "Stage View",
    "page": "Quality Control",
    "path": "/qc",
    "find": "Stage View"
  },
  {
    "id": "widget:/qc/audits:audits",
    "kind": "widget",
    "name": "Audits",
    "page": "QCAudits",
    "path": "/qc/audits",
    "find": "Audits"
  },
  {
    "id": "widget:/qc/audits:templates",
    "kind": "widget",
    "name": "Templates",
    "page": "QCAudits",
    "path": "/qc/audits",
    "find": "Templates"
  },
  {
    "id": "widget:/qc/compliance:active-country-buyer-programmes",
    "kind": "widget",
    "name": "Active country / buyer programmes",
    "page": "QCCompliance",
    "path": "/qc/compliance",
    "find": "Active country / buyer programmes"
  },
  {
    "id": "widget:/qc/compliance:approved-laboratories",
    "kind": "widget",
    "name": "Approved laboratories",
    "page": "QCCompliance",
    "path": "/qc/compliance",
    "find": "Approved laboratories"
  },
  {
    "id": "widget:/qc/compliance:container-cold-chain-loading-release",
    "kind": "widget",
    "name": "Container cold-chain & loading release —",
    "page": "QCCompliance",
    "path": "/qc/compliance",
    "find": "Container cold-chain & loading release —"
  },
  {
    "id": "widget:/qc/compliance:open-non-conformances-capa",
    "kind": "widget",
    "name": "Open non-conformances / CAPA",
    "page": "QCCompliance",
    "path": "/qc/compliance",
    "find": "Open non-conformances / CAPA"
  },
  {
    "id": "widget:/qc/compliance:purchase-source-approvals",
    "kind": "widget",
    "name": "Purchase source approvals",
    "page": "QCCompliance",
    "path": "/qc/compliance",
    "find": "Purchase source approvals"
  },
  {
    "id": "widget:/qc/compliance:required-documents",
    "kind": "widget",
    "name": "Required documents",
    "page": "QCCompliance",
    "path": "/qc/compliance",
    "find": "Required documents"
  },
  {
    "id": "widget:/qc/compliance:required-test-evidence",
    "kind": "widget",
    "name": "Required test evidence",
    "page": "QCCompliance",
    "path": "/qc/compliance",
    "find": "Required test evidence"
  },
  {
    "id": "widget:/qc/compliance:risk-based-sampling-plans",
    "kind": "widget",
    "name": "Risk-based sampling plans",
    "page": "QCCompliance",
    "path": "/qc/compliance",
    "find": "Risk-based sampling plans"
  },
  {
    "id": "widget:/qc/compliance:source-history-recommendations",
    "kind": "widget",
    "name": "Source-history recommendations",
    "page": "QCCompliance",
    "path": "/qc/compliance",
    "find": "Source-history recommendations"
  },
  {
    "id": "widget:/qc/compliance:supplier-purchase-source-scorecards",
    "kind": "widget",
    "name": "Supplier & purchase-source scorecards",
    "page": "QCCompliance",
    "path": "/qc/compliance",
    "find": "Supplier & purchase-source scorecards"
  },
  {
    "id": "widget:/qc/eia:buyer-destination",
    "kind": "widget",
    "name": "Buyer / Destination",
    "page": "EIACertificate",
    "path": "/qc/eia",
    "find": "Buyer / Destination"
  },
  {
    "id": "widget:/qc/eia:exporter",
    "kind": "widget",
    "name": "Exporter",
    "page": "EIACertificate",
    "path": "/qc/eia",
    "find": "Exporter"
  },
  {
    "id": "widget:/qc/eia:health-certificate",
    "kind": "widget",
    "name": "Health Certificate —",
    "page": "EIACertificate",
    "path": "/qc/eia",
    "find": "Health Certificate —"
  },
  {
    "id": "widget:/qc/eia:lot-trace",
    "kind": "widget",
    "name": "Lot trace",
    "page": "EIACertificate",
    "path": "/qc/eia",
    "find": "Lot trace"
  },
  {
    "id": "widget:/qc/eia:product",
    "kind": "widget",
    "name": "Product",
    "page": "EIACertificate",
    "path": "/qc/eia",
    "find": "Product"
  },
  {
    "id": "widget:/qc/eia:test-results",
    "kind": "widget",
    "name": "Test results",
    "page": "EIACertificate",
    "path": "/qc/eia",
    "find": "Test results"
  },
  {
    "id": "widget:/qc/gates:new-inspection",
    "kind": "widget",
    "name": "New Inspection",
    "page": "QCGates",
    "path": "/qc/gates",
    "find": "New Inspection"
  },
  {
    "id": "widget:/qc/gates:recent-inspections",
    "kind": "widget",
    "name": "Recent inspections —",
    "page": "QCGates",
    "path": "/qc/gates",
    "find": "Recent inspections —"
  },
  {
    "id": "tab:/qc/lab:inspections",
    "kind": "tab",
    "name": "Inspections",
    "page": "QCLab",
    "path": "/qc/lab",
    "tab": "inspections",
    "find": "Inspections"
  },
  {
    "id": "tab:/qc/lab:panel",
    "kind": "tab",
    "name": "Test Panel",
    "page": "QCLab",
    "path": "/qc/lab",
    "tab": "panel",
    "find": "Test Panel"
  },
  {
    "id": "widget:/qc/lab:structured-inspections",
    "kind": "widget",
    "name": "Structured Inspections",
    "page": "QCLab",
    "path": "/qc/lab",
    "find": "Structured Inspections"
  },
  {
    "id": "widget:/qc/lab:test-panel",
    "kind": "widget",
    "name": "Test Panel",
    "page": "QCLab",
    "path": "/qc/lab",
    "find": "Test Panel"
  },
  {
    "id": "widget:/qc/masters:checkpoint-gates",
    "kind": "widget",
    "name": "Checkpoint Gates",
    "page": "QCMasters",
    "path": "/qc/masters",
    "find": "Checkpoint Gates"
  },
  {
    "id": "widget:/qc/masters:tests",
    "kind": "widget",
    "name": "Tests",
    "page": "QCMasters",
    "path": "/qc/masters",
    "find": "Tests"
  },
  {
    "id": "widget:/qc/uniformity:open-a-sheet",
    "kind": "widget",
    "name": "Open a sheet",
    "page": "Uniformity QC",
    "path": "/qc/uniformity",
    "find": "Open a sheet"
  },
  {
    "id": "widget:/qc/uniformity:samples-on-this-sheet",
    "kind": "widget",
    "name": "Samples on this sheet",
    "page": "Uniformity QC",
    "path": "/qc/uniformity",
    "find": "Samples on this sheet"
  },
  {
    "id": "widget:/qc/uniformity:sheets-still-open",
    "kind": "widget",
    "name": "Sheets still open",
    "page": "Uniformity QC",
    "path": "/qc/uniformity",
    "find": "Sheets still open"
  },
  {
    "id": "widget:/qc/uniformity/dashboard:uniformity-qc-due",
    "kind": "widget",
    "name": "Uniformity QC due",
    "page": "Uniformity Dashboard",
    "path": "/qc/uniformity/dashboard",
    "find": "Uniformity QC due"
  },
  {
    "id": "tab:/qc/uniformity/masters:machines",
    "kind": "tab",
    "name": "Grading Machines",
    "page": "Uniformity Masters",
    "path": "/qc/uniformity/masters",
    "tab": "machines",
    "find": "Grading Machines"
  },
  {
    "id": "tab:/qc/uniformity/masters:parameters",
    "kind": "tab",
    "name": "Sheet Rows",
    "page": "Uniformity Masters",
    "path": "/qc/uniformity/masters",
    "tab": "parameters",
    "find": "Sheet Rows"
  },
  {
    "id": "tab:/qc/uniformity/masters:specs",
    "kind": "tab",
    "name": "Uniformity Specifications",
    "page": "Uniformity Masters",
    "path": "/qc/uniformity/masters",
    "tab": "specs",
    "find": "Uniformity Specifications"
  },
  {
    "id": "widget:/qc/uniformity/masters:add-a-grading-machine",
    "kind": "widget",
    "name": "Add a grading machine",
    "page": "Uniformity Masters",
    "path": "/qc/uniformity/masters",
    "find": "Add a grading machine"
  },
  {
    "id": "widget:/qc/uniformity/masters:grading-machines",
    "kind": "widget",
    "name": "Grading machines",
    "page": "Uniformity Masters",
    "path": "/qc/uniformity/masters",
    "find": "Grading machines"
  },
  {
    "id": "widget:/qc/uniformity/masters:inspection-sheet-rows",
    "kind": "widget",
    "name": "Inspection sheet rows",
    "page": "Uniformity Masters",
    "path": "/qc/uniformity/masters",
    "find": "Inspection sheet rows"
  },
  {
    "id": "widget:/qc/uniformity/masters:specifications",
    "kind": "widget",
    "name": "Specifications",
    "page": "Uniformity Masters",
    "path": "/qc/uniformity/masters",
    "find": "Specifications"
  },
  {
    "id": "widget:/raw-material-pool:plant-raw-material-entry",
    "kind": "widget",
    "name": "Plant Raw Material Entry",
    "page": "Raw Material Pool",
    "path": "/raw-material-pool",
    "find": "Plant Raw Material Entry"
  },
  {
    "id": "widget:/raw-material-pool:sold-on-to-other-plants",
    "kind": "widget",
    "name": "Sold On To Other Plants",
    "page": "Raw Material Pool",
    "path": "/raw-material-pool",
    "find": "Sold On To Other Plants"
  },
  {
    "id": "widget:/reports:blank-registers-empty-for-manual-records",
    "kind": "widget",
    "name": "Blank registers (empty, for manual records)",
    "page": "Reports",
    "path": "/reports",
    "find": "Blank registers (empty, for manual records)"
  },
  {
    "id": "widget:/reports:costing-analysis",
    "kind": "widget",
    "name": "Costing Analysis",
    "page": "Reports",
    "path": "/reports",
    "find": "Costing Analysis"
  },
  {
    "id": "widget:/reports:finished-goods",
    "kind": "widget",
    "name": "Finished Goods",
    "page": "Reports",
    "path": "/reports",
    "find": "Finished Goods"
  },
  {
    "id": "widget:/reports:how-this-production-day-fanned-out",
    "kind": "widget",
    "name": "How this production day fanned out",
    "page": "Reports",
    "path": "/reports",
    "find": "How this production day fanned out"
  },
  {
    "id": "widget:/reports:per-production-day-yield-cost",
    "kind": "widget",
    "name": "Per-Production Day Yield & Cost",
    "page": "Reports",
    "path": "/reports",
    "find": "Per-Production Day Yield & Cost"
  },
  {
    "id": "widget:/reports:read-out",
    "kind": "widget",
    "name": "Read-out",
    "page": "Reports",
    "path": "/reports",
    "find": "Read-out"
  },
  {
    "id": "widget:/reports:waterfall",
    "kind": "widget",
    "name": "Waterfall —",
    "page": "Reports",
    "path": "/reports",
    "find": "Waterfall —"
  },
  {
    "id": "widget:/reports:where-it-sits-now",
    "kind": "widget",
    "name": "Where it sits now",
    "page": "Reports",
    "path": "/reports",
    "find": "Where it sits now"
  },
  {
    "id": "widget:/reports:where-the-weight-went",
    "kind": "widget",
    "name": "Where the weight went",
    "page": "Reports",
    "path": "/reports",
    "find": "Where the weight went"
  },
  {
    "id": "tab:/sales:benefits",
    "kind": "tab",
    "name": "Benefits",
    "page": "Sales",
    "path": "/sales",
    "tab": "benefits",
    "find": "Benefits"
  },
  {
    "id": "tab:/sales:buyers",
    "kind": "tab",
    "name": "Buyers",
    "page": "Sales",
    "path": "/sales",
    "tab": "buyers",
    "find": "Buyers"
  },
  {
    "id": "tab:/sales:control-tower",
    "kind": "tab",
    "name": "Export Control Tower",
    "page": "Sales",
    "path": "/sales",
    "tab": "control-tower",
    "find": "Export Control Tower"
  },
  {
    "id": "tab:/sales:export-status",
    "kind": "tab",
    "name": "Export Status",
    "page": "Sales",
    "path": "/sales",
    "tab": "export-status",
    "find": "Export Status"
  },
  {
    "id": "tab:/sales:procurement-alerts",
    "kind": "tab",
    "name": "Procurement Alerts",
    "page": "Sales",
    "path": "/sales",
    "tab": "procurement-alerts",
    "find": "Procurement Alerts"
  },
  {
    "id": "tab:/sales:orders",
    "kind": "tab",
    "name": "Sales Orders",
    "page": "Sales",
    "path": "/sales",
    "tab": "orders",
    "find": "Sales Orders"
  },
  {
    "id": "tab:/sales:shipments",
    "kind": "tab",
    "name": "Shipments",
    "page": "Sales",
    "path": "/sales",
    "tab": "shipments",
    "find": "Shipments"
  },
  {
    "id": "tab:/sales:templates",
    "kind": "tab",
    "name": "Templates",
    "page": "Sales",
    "path": "/sales",
    "tab": "templates",
    "find": "Templates"
  },
  {
    "id": "widget:/sales:alerts",
    "kind": "widget",
    "name": "Alerts",
    "page": "Sales",
    "path": "/sales",
    "find": "Alerts"
  },
  {
    "id": "widget:/sales:amendment-control",
    "kind": "widget",
    "name": "Amendment control",
    "page": "Sales",
    "path": "/sales",
    "find": "Amendment control"
  },
  {
    "id": "widget:/sales:document-templates",
    "kind": "widget",
    "name": "Document Templates",
    "page": "Sales",
    "path": "/sales",
    "find": "Document Templates"
  },
  {
    "id": "widget:/sales:drawback-rodtep-tracking",
    "kind": "widget",
    "name": "Drawback / RoDTEP Tracking",
    "page": "Sales",
    "path": "/sales",
    "find": "Drawback / RoDTEP Tracking"
  },
  {
    "id": "widget:/sales:export-buyers",
    "kind": "widget",
    "name": "Export Buyers",
    "page": "Sales",
    "path": "/sales",
    "find": "Export Buyers"
  },
  {
    "id": "widget:/sales:export-control-tower",
    "kind": "widget",
    "name": "Export Control Tower",
    "page": "Sales",
    "path": "/sales",
    "find": "Export Control Tower"
  },
  {
    "id": "widget:/sales:export-status-report",
    "kind": "widget",
    "name": "Export Status Report",
    "page": "Sales",
    "path": "/sales",
    "find": "Export Status Report"
  },
  {
    "id": "widget:/sales:mandatory-evidence",
    "kind": "widget",
    "name": "Mandatory evidence",
    "page": "Sales",
    "path": "/sales",
    "find": "Mandatory evidence"
  },
  {
    "id": "widget:/sales:owner-task-plan",
    "kind": "widget",
    "name": "Owner task plan",
    "page": "Sales",
    "path": "/sales",
    "find": "Owner task plan"
  },
  {
    "id": "widget:/sales:plan-procurement-for-an-order",
    "kind": "widget",
    "name": "Plan procurement for an order",
    "page": "Sales",
    "path": "/sales",
    "find": "Plan procurement for an order"
  },
  {
    "id": "widget:/sales:sales-orders",
    "kind": "widget",
    "name": "Sales Orders",
    "page": "Sales",
    "path": "/sales",
    "find": "Sales Orders"
  },
  {
    "id": "widget:/sales:saved-plans",
    "kind": "widget",
    "name": "Saved plans",
    "page": "Sales",
    "path": "/sales",
    "find": "Saved plans"
  },
  {
    "id": "widget:/sales:shipments",
    "kind": "widget",
    "name": "Shipments",
    "page": "Sales",
    "path": "/sales",
    "find": "Shipments"
  },
  {
    "id": "widget:/traceability:carton-to-root-trace",
    "kind": "widget",
    "name": "Carton-to-root trace",
    "page": "Traceability",
    "path": "/traceability",
    "find": "Carton-to-root trace"
  },
  {
    "id": "widget:/traceability:forward-trace",
    "kind": "widget",
    "name": "Forward Trace",
    "page": "Traceability",
    "path": "/traceability",
    "find": "Forward Trace"
  },
  {
    "id": "widget:/traceability:lot-activity-log",
    "kind": "widget",
    "name": "Lot Activity Log",
    "page": "Traceability",
    "path": "/traceability",
    "find": "Lot Activity Log"
  },
  {
    "id": "widget:/traceability:lot-health-flow",
    "kind": "widget",
    "name": "Lot Health % flow",
    "page": "Traceability",
    "path": "/traceability",
    "find": "Lot Health % flow"
  },
  {
    "id": "widget:/traceability:lot-line-item-trace-line-s",
    "kind": "widget",
    "name": "Lot Line Item Trace line(s)",
    "page": "Traceability",
    "path": "/traceability",
    "find": "Lot Line Item Trace line(s)"
  },
  {
    "id": "widget:/traceability:material-journey-linked-movement-s",
    "kind": "widget",
    "name": "Material Journey linked movement(s)",
    "page": "Traceability",
    "path": "/traceability",
    "find": "Material Journey linked movement(s)"
  },
  {
    "id": "widget:/traceability:ponds-behind-this-order-pond-s-production-day-s",
    "kind": "widget",
    "name": "Ponds Behind This Order pond(s) production day(s)",
    "page": "Traceability",
    "path": "/traceability",
    "find": "Ponds Behind This Order pond(s) production day(s)"
  },
  {
    "id": "widget:/traceability:trace-documents",
    "kind": "widget",
    "name": "Trace Documents",
    "page": "Traceability",
    "path": "/traceability",
    "find": "Trace Documents"
  },
  {
    "id": "widget:/traceability:trace-map",
    "kind": "widget",
    "name": "Trace Map",
    "page": "Traceability",
    "path": "/traceability",
    "find": "Trace Map"
  },
  {
    "id": "widget:/traceability:traceability-metrics",
    "kind": "widget",
    "name": "Traceability Metrics",
    "page": "Traceability",
    "path": "/traceability",
    "find": "Traceability Metrics"
  }
];

export default DESTINATIONS;
